module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.item && _vm.item.fields && _vm.item.fields.length) ? _c('div', {
    staticClass: "mb-4"
  }, _vm._l((_vm.item.fields), function(element, index) {
    return _c('div', {
      key: index
    }, [(element.values) ? _c('field-view', {
      attrs: {
        "field": element.field,
        "is-encrypted": element.isEncrypted,
        "value": element.values
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.item,
      "rules": _vm.validation,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "reservation.fullname"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "fullname"
    },
    model: {
      value: (_vm.item.reservation.fullname),
      callback: function($$v) {
        _vm.$set(_vm.item.reservation, "fullname", $$v)
      },
      expression: "item.reservation.fullname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Party size",
      "prop": "reservation.partySize"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": function($event) {
        return _vm.updateEndtime()
      }
    },
    model: {
      value: (_vm.item.reservation.partySize),
      callback: function($$v) {
        _vm.$set(_vm.item.reservation, "partySize", $$v)
      },
      expression: "item.reservation.partySize"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "4"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "5"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "6"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "7"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "8"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "9"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "10"
    }
  }), _vm._v(" "), _c('div', [_c('el-radio-button', {
    attrs: {
      "label": "11"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "12"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "14"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "16"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "18"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "20"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "25"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "30"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "35"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "40"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date",
      "prop": "reservation.reservationDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd.MM.yyyy",
      "type": "date",
      "placeholder": "Pick a day"
    },
    model: {
      value: (_vm.reservationDate),
      callback: function($$v) {
        _vm.reservationDate = $$v
      },
      expression: "reservationDate"
    }
  }), _vm._v("\n      from\n      "), _c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      "placeholder": "Select time"
    },
    model: {
      value: (_vm.reservationTime),
      callback: function($$v) {
        _vm.reservationTime = $$v
      },
      expression: "reservationTime"
    }
  }), _vm._v(" to\n      "), _c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      "placeholder": "Select time"
    },
    model: {
      value: (_vm.item.reservation.leavingTime),
      callback: function($$v) {
        _vm.$set(_vm.item.reservation, "leavingTime", $$v)
      },
      expression: "item.reservation.leavingTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "reservation.phone"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phone"
    },
    model: {
      value: (_vm.item.reservation.phone),
      callback: function($$v) {
        _vm.$set(_vm.item.reservation, "phone", $$v)
      },
      expression: "item.reservation.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Comment",
      "prop": "reservation.comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.item.reservation.comment),
      callback: function($$v) {
        _vm.$set(_vm.item.reservation, "comment", $$v)
      },
      expression: "item.reservation.comment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Room",
      "prop": "reservation.reservationRoom"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select room"
    },
    model: {
      value: (_vm.item.reservation.reservationRoom),
      callback: function($$v) {
        _vm.$set(_vm.item.reservation, "reservationRoom", $$v)
      },
      expression: "item.reservation.reservationRoom"
    }
  }, _vm._l((_vm.rooms), function(room) {
    return _c('el-option', {
      key: room._id,
      attrs: {
        "label": room.title,
        "value": room._id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tables",
      "prop": "reservation.reservationTables"
    }
  }, [_c('div', [_vm._l((_vm.item.reservation.reservationTables), function(table, i) {
    return _c('div', {
      key: i,
      staticClass: "mb-2"
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Select table"
      },
      model: {
        value: (_vm.item.reservation.reservationTables[i]),
        callback: function($$v) {
          _vm.$set(_vm.item.reservation.reservationTables, i, $$v)
        },
        expression: "item.reservation.reservationTables[i]"
      }
    }, _vm._l((_vm.tables), function(table) {
      return _c('el-option', {
        key: table.title,
        attrs: {
          "label": table.title + ' (' + table.size + (table.size == '1' ? ' person)' : ' people)'),
          "value": table.title
        }
      })
    }), 1), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeTable(i)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])], 1)
  }), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTable($event)
      }
    }
  }, [_vm._v("Add table")])])], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [(_vm.item._id) ? _c('span', [_vm._v("Save")]) : _c('span', [_vm._v("Create")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("\n        Close\n      ")]), _vm._v(" "), (!_vm.item.reservation.isArrived) ? _c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onArrived
    }
  }, [_vm._v("\n        Guests arrived\n      ")]) : _c('el-button', {
    attrs: {
      "type": "success",
      "outline": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onNotArrived
    }
  }, [_vm._v("\n        Guests not arrived\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("\n        Cancel order\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aa23196"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/CreateOrderDialog.vue
// module id = 430
// module chunks = 4